import { render, staticRenderFns } from "./InstantAppCreate.vue?vue&type=template&id=2ad8a205"
import script from "./InstantAppCreate.vue?vue&type=script&lang=js"
export * from "./InstantAppCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports